import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Navbar from "../../../layout/Navbar";
import HrmsSidebar from "./HrmsSidebar";

export default function HrmsLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="app-shell">
      <HrmsSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="app-main">
        <Navbar onMenuToggle={() => setSidebarOpen((open) => !open)} />

        <main className="app-content">
          <div key={location.pathname} className="content-inner page-enter">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
